// export const HOST_API_URL = "http://localhost:5151/api/v1";
// export const HOST_API_URL_V2 = "http://localhost:5150/api";

export const HOST_API_URL = "https://dev.dahabPay.com/api/v1";
export const HOST_API_URL_V2 = "https://docsapi.dahabPay.com/api";